import React from 'react';

const urls = {
    "Firemaking": "https://oldschool.runescape.wiki/images/thumb/Firemaking_icon.png/21px-Firemaking_icon.png",
    "Strength": "https://oldschool.runescape.wiki/images/Strength_icon.png",
    "Attack": "https://oldschool.runescape.wiki/images/thumb/Attack_icon.png/21px-Attack_icon.png",
    "Defence": "https://oldschool.runescape.wiki/images/Defence_icon.png",
    "Hunter": "	https://oldschool.runescape.wiki/images/thumb/Hunter_icon.png/20px-Hunter_icon.png",
    "Fishing": "https://oldschool.runescape.wiki/images/thumb/Fishing_icon.png/21px-Fishing_icon.png",
    "Woodcutting": "https://oldschool.runescape.wiki/images/thumb/Woodcutting_icon.png/17px-Woodcutting_icon.png",
    "Crafting": "https://oldschool.runescape.wiki/images/thumb/Crafting_icon.png/21px-Crafting_icon.png",
    "Ranged": "https://oldschool.runescape.wiki/images/thumb/Ranged_icon.png/21px-Ranged_icon.png",
    "Magic": "https://oldschool.runescape.wiki/images/thumb/Magic_icon.png/21px-Magic_icon.png",
    "Herblore": "https://oldschool.runescape.wiki/images/thumb/Herblore_icon.png/21px-Herblore_icon.png",
    "Fletching": "https://oldschool.runescape.wiki/images/thumb/Fletching_icon.png/21px-Fletching_icon.png",
    "Mining": "https://oldschool.runescape.wiki/images/thumb/Mining_icon.png/21px-Mining_icon.png",
    "Prayer": "https://oldschool.runescape.wiki/images/thumb/Prayer_icon.png/21px-Prayer_icon.png",
    "Thieving": "https://oldschool.runescape.wiki/images/thumb/Thieving_icon.png/21px-Thieving_icon.png",
    "Construction": "https://oldschool.runescape.wiki/images/thumb/Construction_icon.png/21px-Construction_icon.png",
    "Agility": "https://oldschool.runescape.wiki/images/thumb/Agility_icon.png/21px-Agility_icon.png",
    "Runecraft": "https://oldschool.runescape.wiki/images/thumb/Runecraft_icon.png/21px-Runecraft_icon.png",
    "Slayer": "https://oldschool.runescape.wiki/images/thumb/Slayer_icon.png/20px-Slayer_icon.png",
    "Farming": "https://oldschool.runescape.wiki/images/thumb/Farming_icon.png/21px-Farming_icon.png",
    "Hitpoints": "https://oldschool.runescape.wiki/images/thumb/Hitpoints_icon.png/21px-Hitpoints_icon.png",
    "Cooking": "https://oldschool.runescape.wiki/images/Cooking_icon.png",
    "Smithing": "https://oldschool.runescape.wiki/images/Smithing_icon.png",
    "Combat level": "https://oldschool.runescape.wiki/images/Attack_style_icon.png",
}



export function SkillDisplay(props){
    const {skills, levels} = props;
    const skillKeys = Object.keys(skills);
    return <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
        {skillKeys.map(x => {
            let borderColor = "black";
            let title = x;
            if(levels && levels[x]){
                borderColor = levels[x] >= skills[x] ? 'green' : 'red';
                title += "\n" + "Current level: " + levels[x];
            }
            return <div className={"skill-amount-cont"} style={{display: 'flex', padding: "4px", margin: "4px", border: '2px solid ' + borderColor, borderRadius: '4px'}}>
                <SkillIcon skill={x} title={title}/>
                <span className="skill-amount">{skills[x]}</span>
            </div>
        })}
    </div>
}

export function SkillIcon(props){
    const {skill} = props;
    return <img className={"skill-icon"} src={urls[skill]} alt={skill} title={props.title || skill} style={{width: "16px", height: "16px"}}/>
}